// Frontend analytics via Azure Application Insights (resource:
// appi-amanar-leadengine-dev). Tracks page views — including SPA route
// changes — plus sessions and referrers, so the daily report can show real
// visits/traffic. Dormant if the connection string isn't set (local dev).
//
// The instrumentation key is public by design (it ships in client code, like
// a GA tag) — telemetry is write-only to the ingestion endpoint.

import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const CONNECTION_STRING = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

let ai = null;

export function initAnalytics() {
  if (ai || !CONNECTION_STRING) return ai;
  ai = new ApplicationInsights({
    config: {
      connectionString: CONNECTION_STRING,
      // We drive page views manually on route change (SPA), so disable the
      // auto tracker to avoid double-counting.
      enableAutoRouteTracking: false,
      disableFetchTracking: true,        // don't log every API call as a dependency
      disableAjaxTracking: true,
      enableCorsCorrelation: false,
    },
  });
  ai.loadAppInsights();
  return ai;
}

// Call on each route change. `name` is the path so pages group cleanly in
// the portal (e.g. "/new/food/tampa").
export function trackPage(name) {
  if (!ai) return;
  ai.trackPageView({ name: name || window.location.pathname, uri: window.location.pathname });
}
